import type { ButtonThemeType, DropdownThemeType, RadiusThemeType, SizeThemeType } from "@/constants/project-specific/theme/types";
import { dropdownTheme } from "../dropdown";
import type { DefaultTokenListType } from "@/constants/project-specific/types";
import { defaultTokenList } from "@/constants/project-specific/tokens";

export type ConnectButtonTheme = {
    radius: RadiusThemeType;
    size: SizeThemeType;
    states?: ConnectButtonStatesStyle;
    dropdownTheme?: DropdownThemeType;
    erc20BalanceToken?: DefaultTokenListType;
    balanceColor?: string;
}
export type ConnectButtonStatesStyle = {
    connected: ButtonThemeType;
    connecting: ButtonThemeType;
    disconnected: ButtonThemeType;
    reconnecting?: ButtonThemeType;
}

export const connectBtnTheme: ConnectButtonTheme = {
    radius: "md",
    size: "md",
    dropdownTheme: dropdownTheme,
    states: {
        connected: {
            size: "md",
            radius: "lg",
            variant: "ghost",
            color: "secondary",
            className: "",
        },
        connecting: {
            text: "Connecting...",
            size: "md",
            radius: "lg",
            variant: "shadow",
            color: "secondary",
            spinnerPlacement: "start",
        },
        disconnected: {
            text: "Connect",
            size: "md",
            radius: "lg",
            variant: "shadow",
            color: "secondary",
        },
        reconnecting: {
            text: "Chasing squirrel",
        },
    },
    erc20BalanceToken: defaultTokenList,
}